module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('logo', {
    attrs: {
      "no-header": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "map-title row"
  }, [_c('div', {
    staticClass: "map-title__content col-xs-12 "
  }, [_c('h1', {
    staticClass: "map-title__title"
  }, [_vm._v("\n        " + _vm._s(_vm.name) + " nade spots\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Select the map you want to learn nade spots for.   \n      ")]), _vm._v(" "), _c('div', {
    staticClass: "map-title__back-button-container"
  }, [_c('router-link', {
    staticClass: "map-title__back-button",
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-android-arrow-back"
  }), _vm._v(" Choose another game\n        ")])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.maps && _vm.maps.length > 0),
      expression: "maps && maps.length > 0"
    }],
    staticClass: "map-selection row center-xs"
  }, _vm._l((_vm.maps), function(map) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4"
    }, [_c('div', {
      staticClass: "map-selection__item box dropShadow",
      style: (("background-image:url(" + (map.thumbnail) + ")"))
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Dashboard',
          params: {
            map: _vm.createLink(map.slug)
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(map.name) + "\n        ")])], 1)])
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fetchingMaps),
      expression: "fetchingMaps"
    }]
  }, [_c('loader')], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fetchingMaps && (!_vm.maps || _vm.maps.length === 0)),
      expression: "!fetchingMaps && (!maps || maps.length === 0)"
    }],
    staticClass: "no-maps-found"
  }, [_vm._v("\n    No maps found for this game.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "add-map row center-xs"
  }, [_c('router-link', {
    staticClass: "add-map__button",
    attrs: {
      "to": {
        name: 'MapSelectionAdd'
      }
    }
  }, [_vm._v("\n      Add a map\n    ")])], 1), _vm._v(" "), (_vm.$route.name !== 'MapSelection') ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.$router.push({
          name: 'MapSelection'
        })
      }
    }
  }, [_c('router-view', {
    attrs: {
      "user": _vm.user
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7188d5a1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/MapSelection/index.vue
// module id = 718
// module chunks = 1